import { Dispatch, useEffect, useState } from 'react';
import { compose as lcompose, map as lmap, filter as lfilter } from 'lodash/fp';
import { assocPath, equals, pathOr } from 'rambda';
import { fold, map as emap } from 'fp-ts/lib/Either';
import {
  getApproverRequests,
  getHeaders,
  IApiCallStatus,
  IError,
  IRequest,
  ISaveRequestOutput,
  ResponseCSOSHeaders,
  useUserContext,
} from '../common';

export const useApproverRequests = () => {
  const { user } = useUserContext();
  const [requests, setRequests] = useState<ISaveRequestOutput[]>([]);
  const [apiCallStatus, setApiCallStatus] = useState<IApiCallStatus>();

  useEffect(() => {
    lcompose(
      emap(handleRequests({ setRequests, setApiCallStatus })),
      getHeaders
    )(user);
  }, [user]);

  return { requests, apiCallStatus };
};

const handleRequests = ({
  setRequests,
  setApiCallStatus,
}: {
  setRequests: Dispatch<ISaveRequestOutput[]>;
  setApiCallStatus: Dispatch<IApiCallStatus>;
}) =>
  lcompose(
    () => setApiCallStatus(null),
    (hR: ResponseCSOSHeaders) =>
      getApproverRequests(hR)
        .then(
          fold<IError, IRequest[], void>(
            () => setApiCallStatus(false),

            lcompose(
              () => setApiCallStatus(true),
              setRequests,
              lfilter(({ sailpointCaseId }) => sailpointCaseId !== null),
              lmap<IRequest, ISaveRequestOutput>(
                lcompose(assocPath('msgCode', null), assocPath('msgText', null))
              ),
              lfilter<IRequest>(
                lcompose(equals('IN_PROCESS'), pathOr('', 'status'))
              )
            )
          )
        )
        .catch(() => setApiCallStatus(false))
  );
